var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImojiDash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 56.5,
    height: 56.5,
    rx: 28.25,
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.704 25.11C19.022 25.11 18.494 24.582 18.494 23.9C18.494 23.218 19.022 22.668 19.704 22.668C20.386 22.668 20.936 23.218 20.936 23.9C20.936 24.582 20.386 25.11 19.704 25.11ZM19.704 35.89C19.022 35.89 18.494 35.362 18.494 34.68C18.494 33.998 19.022 33.448 19.704 33.448C20.386 33.448 20.936 33.998 20.936 34.68C20.936 35.362 20.386 35.89 19.704 35.89ZM24.3975 30.016V28.564H31.2615V30.016H24.3975ZM39.2687 29.29C39.2687 33.866 37.5747 37.716 34.5387 40.994L33.4607 40.026C36.3867 36.748 37.7287 33.14 37.7287 29.29C37.7287 25.44 36.3867 21.832 33.4607 18.554L34.5387 17.586C37.5747 20.864 39.2687 24.714 39.2687 29.29Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImojiDash2);
export default __webpack_public_path__ + "static/media/Imoji_dash2.8772fde4c85083e3c09c9250c362fd8b.svg";
export { ForwardRef as ReactComponent };